import React from 'react';
import { FlexibleCRUDTable } from '../../components/common/FlexibleCRUDTable';
import { DynamicForm } from '../../components/common/DynamicForm';
import { abacResourceAttributeEntity } from '../../config/entities/abacResourceAttributes';
import { abacResourceAttributeService } from '../../services/abac';
import { toast } from 'react-hot-toast';
import { useLanguage } from '../../state/language/LanguageProvider';

const ResourceAttributesPage: React.FC = () => {
  const [showForm, setShowForm] = React.useState(false);
  const [editingItem, setEditingItem] = React.useState<any>(null);
  const { t } = useLanguage();

  const handleCreate = () => {
    setEditingItem(null);
    setShowForm(true);
  };

  const handleEdit = (item: any) => {
    setEditingItem(item);
    setShowForm(true);
  };

  const handleToggleStatus = async (id: string, isActive: boolean) => {
    try {
      await abacResourceAttributeService.toggleStatus(id, isActive);
      toast.success(t('abac.resourceAttributeStatusUpdated'));
    } catch (error) {
      toast.error(t('abac.failedToUpdateResourceAttributeStatus'));
    }
  };

  const handleDelete = async (item: any) => {
    try {
      await abacResourceAttributeService.delete(item.id);
      toast.success(t('abac.resourceAttributeDeleted'));
    } catch (error) {
      toast.error(t('abac.failedToDeleteResourceAttribute'));
    }
  };

  const handleFormSubmit = async (data: any) => {
    try {
      if (editingItem) {
        await abacResourceAttributeService.update(editingItem.id, data);
        toast.success(t('abac.resourceAttributeUpdated'));
      } else {
        await abacResourceAttributeService.create(data);
        toast.success(t('abac.resourceAttributeCreated'));
      }
      setShowForm(false);
      setEditingItem(null);
    } catch (error) {
      toast.error(t('abac.failedToSaveResourceAttribute'));
    }
  };

  const handleFormCancel = () => {
    setShowForm(false);
    setEditingItem(null);
  };

  return (
    <div className="container mx-auto p-6">
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-gray-900">{t('abac.resourceAttributesManagement')}</h1>
        <p className="text-gray-600 mt-2">
          {t('abac.defineAndManageResourceAttributes')}
        </p>
      </div>

      {showForm ? (
        <DynamicForm
          entity={abacResourceAttributeEntity}
          initialData={editingItem}
          onSubmit={handleFormSubmit}
          onCancel={handleFormCancel}
        />
      ) : (
        <FlexibleCRUDTable
          entity={abacResourceAttributeEntity}
          service={abacResourceAttributeService}
          onEdit={handleEdit}
          onDelete={handleDelete}
          onToggleStatus={handleToggleStatus}
          onCreate={handleCreate}
          onOperationComplete={() => {
            // This will be called after successful operations (create, update, delete)
            // The table will automatically refresh via loadData() in the component
          }}
        />
      )}
    </div>
  );
};

export default ResourceAttributesPage;
